export default __webpack_public_path__ + "be85d56bd5b40961c76a8b6286e0ab23.ico";